// extracted by mini-css-extract-plugin
module.exports = {"section":"AcademicsModule_section__WBjbD","edit":"AcademicsModule_edit__gYeAA","block":"AcademicsModule_block__an36_"};